
export enum DisputeTypeCd {
	DISPUTE_RESOLUTION_PROCESS = 'DisputeResolutionProcess',
	INSPECTION_APPEALS = 'InspectionAppeals',
	MASS_RE_RATE = 'MassReRate',
	OVERCHARGE_CLAIMS = 'OverchargeClaims'}

